import AdmMenusRequests from '../../server/admMenu';
import sessionStorage from '../../services/sessionStorage';
import { addLoading, removeLoading } from './loading';

const setAdmMenus = admMenus => ({
  type: 'GET_ADM_MENUS',
  admMenus,
});

const setAdmMenusSelect = admMenus => ({
  type: 'GET_ADM_MENUS_SELECT',
  admMenus,
});

const setAdmMenu = admMenu => ({
  type: 'GET_ADM_MENU',
  admMenu,
});

const setAdmMenuTree = admMenu => ({
  type: 'GET_ADM_MENU_TREE',
  admMenu,
});

const setAdmMenuRoutes = admMenu => ({
  type: 'GET_ADM_MENU_ROUTES',
  admMenu,
});

const setAdmMenuCurrentLevel = value => ({
  type: 'SET_MENU_CURRENT_LEVEL',
  value,
});

const getAdmMenuStateDispatch = menuState => ({
  type: 'GET_MENU_STATE',
  menuState,
});

const saveAdmMenuCurrentLevel = state => async (dispatch) => {
  dispatch(addLoading());
  try {
    dispatch(setAdmMenuCurrentLevel(state));
  } finally {
    dispatch(removeLoading());
  }
};

const saveAdmMenuState = state => async (dispatch) => {
  dispatch(addLoading());
  try {
    await sessionStorage.set('AdmMenuState', state);
    dispatch(getAdmMenuStateDispatch(state));
  } finally {
    dispatch(removeLoading());
  }
};

const getAdmMenuState = () => async (dispatch) => {
  dispatch(addLoading());
  try {
    const state = await sessionStorage.get('AdmMenuState');
    dispatch(getAdmMenuStateDispatch(state));
  } finally {
    dispatch(removeLoading());
  }
};

/* const getAdmMenuState = () => async (dispatch) => {
  dispatch(addLoading());
  try {
    // let menuState = await AdmMenusRequests.getMenuState();
    // if (!Array.isArray(menuState))
    //   menuState = [];
    // dispatch(getAdmMenuStateDispatch(menuState));
  } finally {
    dispatch(removeLoading());
  }
}; */

const getAdmMenuTree = (userId, profileId) => async (dispatch) => {
  dispatch(addLoading());
  try {
    const admMenus = await AdmMenusRequests.getAdmMenuTree(userId, profileId);
    dispatch(setAdmMenuTree(admMenus));
  } finally {
    dispatch(removeLoading());
  }
};

const getAdmMenuRoutes = (userId, profileId) => async (dispatch) => {
  dispatch(addLoading());
  try {
    const admMenus = await AdmMenusRequests.getAdmMenuRoutes(userId, profileId);
    dispatch(setAdmMenuRoutes(admMenus));
  } finally {
    dispatch(removeLoading());
  }
};

const getAdmMenus = (limit, skip, search = '', order = '', field = '', level) => async (dispatch) => {
  dispatch(addLoading());
  try {
    const admMenus = await AdmMenusRequests.getAdmMenus(limit, skip, search, order, field, level);
    dispatch(setAdmMenus(admMenus));
  } finally {
    dispatch(removeLoading());
  }
};

const getAdmMenusSelect = level => async (dispatch) => {
  dispatch(addLoading());
  try {
    const admMenus = await AdmMenusRequests.getAdmMenus(999, 0, '', 'ASC', 'id', level);
    dispatch(setAdmMenusSelect(admMenus));
  } finally {
    dispatch(removeLoading());
  }
};

const getAdmMenu = id => async (dispatch) => {
  dispatch(addLoading());
  try {
    const admMenu = await AdmMenusRequests.getAdmMenu(id);
    dispatch(setAdmMenu(admMenu));
  } finally {
    dispatch(removeLoading());
  }
};

const createAdmMenu = admMenu => async (dispatch) => {
  dispatch(addLoading());
  try {
    await AdmMenusRequests.createAdmMenu(admMenu);
  } finally {
    dispatch(removeLoading());
  }
};

const updateAdmMenu = admMenu => async (dispatch) => {
  dispatch(addLoading());
  try {
    await AdmMenusRequests.updateAdmMenu(admMenu);
  } finally {
    dispatch(removeLoading());
  }
};

const deleteAdmMenu = id => async (dispatch) => {
  dispatch(addLoading());
  try {
    await AdmMenusRequests.deleteAdmMenu(id);
  } finally {
    dispatch(removeLoading());
  }
};

export const getCsvAdmMenuModel = () => async (dispatch) => {
  dispatch(addLoading());
  try {
    await AdmMenusRequests.getCsvAdmMenuModel();
  } finally {
    dispatch(removeLoading());
  }
};

const getCsvAdmMenusReport = () => async (dispatch) => {
  dispatch(addLoading());
  try {
    await AdmMenusRequests.getCsvAdmMenusReport();
  } finally {
    dispatch(removeLoading());
  }
};

export const uploadAdmMenusCsv = file => async (dispatch) => {
  dispatch(addLoading());
  try {
    const result = await AdmMenusRequests.uploadCsvAdmMenus(file);
    return result;
  } finally {
    dispatch(removeLoading());
  }
};

const uploadAdmMenu = async (file, name, id) => AdmMenusRequests.uploadAdmMenu(file, name, id);

export default {
  getAdmMenus,
  getAdmMenusSelect,
  getAdmMenu,
  getAdmMenuTree,
  getAdmMenuRoutes,
  getAdmMenuState,
  createAdmMenu,
  deleteAdmMenu,
  updateAdmMenu,
  uploadAdmMenu,
  getCsvAdmMenusReport,
  saveAdmMenuState,
  saveAdmMenuCurrentLevel,
};
